<template>
  <div>
    <sp-feature-header :item="item" />
    <b-container>
      <b-row>
        <b-col>
          <page-content-creator
            :itemid="itemid"
            pos="top"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <node-element-local-tasks
            v-if="itemid"
            :itemid="itemid"
          />
          <div
            v-if="notpublished"
            class="messages warning"
          >
            Not published
          </div>
        </b-col>
      </b-row>
    </b-container>
    <section class="page-body">
      <page-content-wysiwg-contentz
        v-if="hasBody"
        :item="item"
      />
    </section>
    <sp-feature-highlights
      :highlights="highlights"
      :highlights-layout="highlightsLayout"
    />
    <sp-feature-feature
      :features-style="featuresStyle"
      :features="features"
    />
    <b-container>
      <b-row>
        <b-col>
          <page-content-creator
            :itemid="itemid"
            pos="bottom"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { asyncLoader, pageMixin, getPreloadImageUrlPromises } from '../../special-pages-common'

function preloadImageUrls({ store, route, router }) {
  if (!route || !store) {
    return Promise.resolve(false)
  }
  applogger.debug('sp-feature: image url loading started')
  return store.dispatch('node/load', { nid: route.path })
    .then(item => {
      return getPreloadImageUrlPromises(
        store,
        ['banner', 'featurepagefeature', 'featurepagehighlight'],
        [[item.field_f_sp_feat_head_image], item.field_f_sp_feat_f_icon, item.field_f_sp_feat_hl_media]
      )
    })
    .then(_ => {
      applogger.debug('sp-feature: image url loading complete')
    })
    .catch(err => {
      applogger.error('sp-feature: image url loading failed')
    })
}

export default {
  name: 'page-content-type-sp-feature',
  mixins: [pageMixin],
  asyncComponents: ['sp-feature-header', 'sp-feature-highlight', 'sp-feature-feature'],
  asyncData: (args) => {
    return args.store.dispatch('promisePool', {
      name: `page-content-type_sp_feature--${args.route.path}`,
      resolve: () => preloadImageUrls(args)
        .then(() => asyncLoader(args))
    })
  },
  computed: {
    featuresStyle() {
      return this.item.field_t_sp_feat_features_style
    },
    features() {
      return this.featurespage.features.filter(feature => feature.title || feature.description)
    },
    highlights() {
      return this.featurespage.highlights.filter(highlight => highlight.title || highlight.description || highlight.leadline)
    },
    highlightsLayout() {
      return this.featurespage.style.highlightsLayout
    },
    featurespage() {
      return {
        style: {
          highlightsLayout: this.item.field_t_sp_feat_hl_layout
        },
        features: Object.keys(this.item.field_t_sp_feat_f_title).map(i => ({
          title: this.item.field_t_sp_feat_f_title[i],
          description: this.item.field_t_sp_feat_f_description[i],
          button: this.item.field_l_sp_feat_f_button[i],
          icon: this.item.field_f_sp_feat_f_icon[i]
            ? {
              data: {
                title: this.item.field_f_sp_feat_f_icon[i].title,
                alt: this.item.field_f_sp_feat_f_icon[i].alt
              },
              ...this.item.field_f_sp_feat_f_icon[i]
            }
            : null
        })),
        highlights: Object.keys(this.item.field_t_sp_feat_hl_title).map(
          i => ({
            title: this.item.field_t_sp_feat_hl_title[i],
            leadline: this.item.field_t_sp_feat_hl_leadline[i],
            description: this.item.field_t_sp_feat_hl_description[i],
            button: this.item.field_l_sp_feat_hl_button1[i],
            media: this.item.field_f_sp_feat_hl_media[i]
              ? {
                data: {
                  title: this.item.field_f_sp_feat_hl_media[i].title,
                  alt: this.item.field_f_sp_feat_hl_media[i].alt
                },
                ...this.item.field_f_sp_feat_hl_media[i]
              }
              : null
          })
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
 ::v-deep .icon-image {
    width: 5em;
    height: 5em;
  }
</style>
